import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignerItemTitleValue,
  ReportDesignItemConfig
} from "../../report-design-item";

@Pipe({
  name: "asTitleValue",
  standalone: false
})
export class ReportItemConfigAsTitleValuePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignerItemTitleValue {
    return <ReportDesignerItemTitleValue>value;
  }
}
